<script setup lang="ts">
import { updateCalendarInviteBody } from '@swipe4work/api-orval'
import {
  calendarInviteBodyPreset,
  useCalendarComposer,
} from '@/composables/useCalendarComposer'
import type { CalendarProviderPreference } from '@/composables/useCalendarComposer'
import CalendarContent from './components/CalendarContent.vue'

definePage({
  name: '/settings/Calendar',
  path: '/instellingen/agenda',
  meta: {
    layout: 'false',
  },
})

const { t } = useI18n()
const toast = useToast()

const companyStore = useCompanyStore()
const calendarInviteBodyRef = ref<string | null>(null)

onMounted(() => {
  calendarInviteBodyRef.value = companyStore.company?.calendarInviteBody || calendarInviteBodyPreset
})

const { calendarPreferenceRef, setCalendarPreference } = useCalendarComposer()

const updateCalendarPreference = (preference: Exclude<CalendarProviderPreference, undefined> | 'none') => {
  const transformedPreference = preference === 'none' ? null : preference

  setCalendarPreference(transformedPreference)

  toast.success(t('settings.userProfile.calendarPreference.updated'))
}

const isSavingCalendarInviteBody = ref(false)

const saveCalendarInviteBody = async () => {
  if (calendarInviteBodyRef.value === null) {
    return
  }

  isSavingCalendarInviteBody.value = true
  try {
    await updateCalendarInviteBody({
      calendarInviteBody: calendarInviteBodyRef.value,
    })

    toast.success(t('settings.changesSaved'))
  } finally {
    isSavingCalendarInviteBody.value = false
  }
}
</script>

<template>
  <CalendarContent
    v-model:calendar-invite-body="calendarInviteBodyRef"
    :calendar-preference="calendarPreferenceRef ?? 'none'"
    :is-saving-calendar-invite-body="isSavingCalendarInviteBody"
    @update-calendar-preference="updateCalendarPreference"
    @save-calendar-invite-body="saveCalendarInviteBody"
  />
</template>
